
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export const updateCustomerEmail = async (customerId: string, email: string) => {
  try {
    const { error } = await supabase
      .from('customers')
      .update({ 
        email: email,
        updated_at: new Date().toISOString() 
      })
      .eq('id', customerId);

    if (error) {
      console.error("Error updating customer email:", error);
      return { success: false, error: error.message };
    }

    console.log("Customer email updated successfully");
    return { success: true };
  } catch (error) {
    console.error("Unexpected error updating customer email:", error);
    return { success: false, error: 'Unexpected error occurred' };
  }
};

export const updateCustomerPhone = async (customerId: string, phone: string) => {
  try {
    const { error } = await supabase
      .from('customers')
      .update({ 
        phone: phone,
        updated_at: new Date().toISOString() 
      })
      .eq('id', customerId);

    if (error) {
      console.error("Error updating customer phone:", error);
      return { success: false, error: error.message };
    }

    console.log("Customer phone updated successfully");
    return { success: true };
  } catch (error) {
    console.error("Unexpected error updating customer phone:", error);
    return { success: false, error: 'Unexpected error occurred' };
  }
};
